import $ from 'jquery';
import LP from './0-lp';
import UI from './0-ui';

LP.Dialog = {

    open: function (params) {
        if (params.name === undefined) {
            params.name = 'lp-dialog';
        }

        params.ref = 'lp-dialogarea-' + params.name;
        params.cssClass = 'lp-dialog';
        params.onSetup = LP.Dialog.onSetup;
        params.onRefreshLanguage = LP.refreshPage;

        UI.Dialog.open(params);
    },

    close: function () {
        UI.Dialog.close();
    },

    getParams: function () {
        return UI.Dialog.params;
    },

    // --------------
    // Callbacks
    // ---------------
    onSetup: function (dialog) {
        var root = dialog.parent();
        var buttons = UI.Dialog.buttons;

        if (typeof buttons != 'undefined' && buttons.length > 0) {
            var numButtons = buttons.length;
            for (var i = 0; i < numButtons; i++) {
                var button = buttons[i];
                button['text'] = unescape(button['text']);
                if (button['className'].indexOf('apply') > -1) {
                    button['click'] = function () {
                        //var prevImg = button['icon'];
                        UI.Dialog.doClose = false;
                        UI.Dialog.doSubmit($('.apply_image', root));
                    };
                } else if (button['className'].indexOf('cancel') > -1) {
                    button['click'] = function () {
                        UI.Dialog.close();
                    };
                } else if (button['className'].indexOf('submit') > -1) {
                    button['click'] = function () {
                        UI.Dialog.doClose = true;
                        UI.Dialog.doSubmit($('.submit_image', root));
                    };
                }
            }
        }

        dialog.dialog('option', 'buttons', UI.Dialog.buttons);

        if (UI.Dialog.buttons) {
            $.each(UI.Dialog.buttons, function (name, button) {
                var btn = $('.ui-dialog-buttonpane', root).find('button#' + button['id'] + '');
                // btn.removeClass('ui-state-default').addClass('lp-section-header');
                btn.unbind('hover');
                btn.addClass(button.className);

                if (button['icon']) {
                    btn.addClass('lp-button-icon-text');

                    if (button['iconPos'] == 'right') {
                        $('.ui-button-text', btn).append('<img class="' + button['iconClass'] + '" src="' + button['icon'] + '" />');
                    } else {
                        $('.ui-button-text', btn).prepend('<img class="' + button['iconClass'] + '" src="' + button['icon'] + '" />');
                    }
                }

                if (button['jqIcon']) {

                    if (button['iconPos'] == 'right') {
                        btn.removeClass('ui-button-text-only').addClass('ui-button-text-icon-secondary');
                        // btn.append('<span class="ui-button-icon-secondary ui-icon ' + button[ 'jqIcon' ] + '"></span>');
                        btn.append('<i class="ui-button-icon-secondary ' + button['jqIcon'] + '"></i>');
                    } else {
                        btn.removeClass('ui-button-text-only').addClass('ui-button-text-icon-primary');
                        btn.prepend('<i class="' + button['jqIcon'] + '"></i>');
                    }
                }

            });
        }

        // Button belegungen.
        $('form', root).submit(function () {
            return false;
        });

        //$('.ui-dialog-titlebar', root).append($('.dialog_languages',dialog));

        $('a[action="gotoLink"]', root).click(function () {
            UI.Dialog.close();
            return true;
        });

        // Disabled : auto-ok on Enter in Dialog
        //$(ref+' form input,'+ref+' form textarea,'+ref+' form select').keyup(function(e) { if(e.keyCode == 13) {UI.Dialog.doClose = true; UI.Dialog.submit(); return false;} });

    },

    // --------------
    // Proxy Methods
    // ---------------
    getInstance: function () {
        return UI.Dialog.getInstance();
    },

    onOpen: function () {
        UI.Dialog.onOpen();
    },
    onClose: function () {
        UI.Dialog.onClose();
    },
    onChangeLanguage: function (lang) {
        UI.Dialog.onChangeLanguage(lang);
    },

    executeSubmit: function (onSuccess, onError) {
        return UI.Dialog.executeSubmit(onSuccess, onError);
    },

    showError: function (json, div, resize) {
        return UI.Dialog.showError(json, div, resize);
    },
    hideErrors: function () {
        return UI.Dialog.hideErrors();
    },

    // --------------
    // Tabs Methods
    // ---------------
    initTabs: function (params) {
        UI.Dialog.Tabs.init('.lp-dialog-tabs', params);
        return true;
    },

    getTabName: function () {
        return UI.Dialog.Tabs.getCurrentTabName();
    },

    getTabIndex: function () {
        return UI.Dialog.Tabs.getCurrentTabIndex();
    },

    selectTab: function (position) {
        return UI.Dialog.Tabs.selectTab(position);
    },

    reloadTab: function () {
        return UI.Dialog.Tabs.reloadCurrent();
    }
};


